export default "__VITE_ASSET__e65c2b43__"